import React from 'react'
import { Eye, Shield, Wifi } from 'lucide-react'

const SolutionSection = () => {
  return (
    <section className="section-padding">
      <div className="container-padding">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Plug-and-play Wi-Fi sensor. Instant insights.
          </h2>
          <p className="text-lg text-blue-600 font-medium mb-4">
            Installs in under 2 minutes. Just plug it in.
          </p>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our discreet device listens for anonymous smartphone Wi-Fi pings — a reliable signal of
            real-world foot traffic. Data flows automatically to your dashboard, giving you clarity in minutes:
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="flex items-start gap-4">
              <Eye className="w-8 h-8 text-green-600 mt-1 flex-shrink-0" />
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">No cameras.</h3>
                <p className="text-gray-600">Privacy-friendly detection without visual surveillance.</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <Shield className="w-8 h-8 text-green-600 mt-1 flex-shrink-0" />
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">No personal data.</h3>
                <p className="text-gray-600">Anonymous signals only. No tracking, no identification.</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <Wifi className="w-8 h-8 text-green-600 mt-1 flex-shrink-0" />
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">No tech setup required.</h3>
                <p className="text-gray-600">Plug it in and start seeing insights immediately.</p>
              </div>
            </div>
            <p className="text-gray-600 mt-4 pl-12 border-l-2 border-blue-200 py-2">
              The sensor anonymously detects Wi-Fi signals already emitted by phones — no cameras, no tracking, no personal data.
            </p>
          </div>

          <div className="relative">
            {/* Sensor Image Placeholder */}
            <div className="card-shadow p-8">
              <div className="aspect-video bg-gradient-to-br from-gray-100 to-gray-200 rounded-lg flex items-center justify-center mb-4">
                <img
                  src="/assets/sensor-placeholder.png"
                  alt="FlowBeatIQ Wi-Fi Sensor"
                  className="max-h-full max-w-full object-contain rounded-lg"
                  onError={(e) => {
                    // Fallback if image doesn't exist
                    const target = e.target as HTMLImageElement
                    target.style.display = 'none'
                    target.parentElement!.innerHTML = `
                      <div class="flex flex-col items-center justify-center text-gray-400">
                        <svg class="w-16 h-16 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.14 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0"></path>
                        </svg>
                        <span class="text-sm">Sensor Image</span>
                      </div>
                    `
                  }}
                />
              </div>
              <p className="text-center text-sm text-gray-500">
                Small plug-in sensor. No cameras. No personal data.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SolutionSection
